import React from 'react';
import { Empty, Button, Col, Radio, Row, Select, Table, Typography } from "antd";
import FloatLabelNumberComponent from "./common/FloatLabelNumberComponent";
import FloatLabelInputComponent from "./common/FloatLabelInputComponent";
import utils from "../common/utils";
import { Translation } from "react-i18next";
import LoadingSvg from "./common/LoadingSvg";
import consts, { PREFIX_FRONT_URL } from "../consts";
import { debounce, isEmpty, map, get, find, values, first, chain } from 'lodash';
import { object, number, string } from 'yup';
import ConfirmModal from './modals/ConfirmModal';
import ModalAndLoadingAndValidateComponent from './common/ModalValidateLoadingComponent';
import { LinkOutlined } from '@ant-design/icons';
import BigNumber from "bignumber.js";

const { Text } = Typography;
const { Option } = Select;

class WithdrawalComponent extends ModalAndLoadingAndValidateComponent {

	columns = (t) => [
		{
			align: "center",
			title: t('user.transaction.id'),
			width: 60,
			dataIndex: 'id',
		},
		{
			title: t('user.withdrawal.currency'),
			width: 200,
			dataIndex: 'currency',
			key: 'currency',
			render: this.getName,
		},
		{
			align: "center",
			title: t('user.withdrawal.fee'),
			width: 100,
			dataIndex: 'fee',
			key: 'fee',
			render: (fee) => utils.formatCurrency(fee)
		},
		{
			align: "center",
			title: t('user.withdrawal.amount'),
			width: 150,
			dataIndex: 'amount',
			key: 'amount',
			render: (amount) => utils.formatCurrency(amount)
		},
		{
			align: "center",
			title: t('user.withdrawal.status'),
			width: 160,
			dataIndex: 'status',
			key: 'status',
			render: (status) => t(utils.parseTranStatus(status)),
		},
		{
			align: "center",
			title: t('user.withdrawal.withdrawal_date'),
			width: 200,
			dataIndex: 'created_at',
			key: 'created_at',
			render: (createdAt) => utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm:ss'),
		},
		{
			align: "center",
			width: 100,
			title: t('user.withdrawal.detail'),
			dataIndex: 'tx_hash',
			key: 'tx_hash',
			render: (tx_hash, item) => this.getLink(tx_hash, item),
		},

	]

	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			params: {
				address: '',
				amount: 0,
				pubkey: '',
			},
			searchText: '',
			gasPrice: 'FASTEST',
			value: '',
			coin: undefined,
			init: true,
		};

		this.useQuery = this.useQuery.bind(this);
	}

	componentDidMount() {
		if (!isEmpty(this.props.coins)) {
			const query = this.useQuery();
			this.handleChange(query.get("coin") || 'ETH');
		}
		this.fetchWithdrawalHistory(0, 5);
	}

	useQuery() {
		return new URLSearchParams(this.props.history.location.search);
	}

	withdrawal = debounce(() => {
		const coinType = get(this.state.coin, 'type', '');

		this.hideModal();
		this.enLoading();

		if (coinType === consts.CUSTOM_COIN) {
			this.props.onWithdrawalCustomCoin({
				pubkey: this.state.params.pubkey,
				amount: this.state.params.amount,
				currency: this.state.coin.coin,
			}, () => {
				this.unLoading();
				this.setState({ params: {} });
			})
		} else {
			this.props.onWithdrawal({
				address: this.state.params.address,
				amount: this.state.params.amount,
				currency: this.state.coin.coin,
				contract: this.state.coin.contract_address,
				gas_price: this.state.gasPrice,
			}, () => {
				this.unLoading();
				this.setState({ params: {} });
			})
		}
	}, consts.DEFAULT_DURATION);

	fetchWithdrawalHistory(pos, count) {
		this.props.onFetchTransactionHistory({
			pos,
			count,
			trans_type: window.c.TRANSACTION_TYPE_WITHDRAW,
			status: -1,
		},
		);
	}

	handleSearch = (searchText) => {
		this.setState({ searchText });
	}

	componentWillReceiveProps(nextProps, propsContext) {
		if (this.state.init && utils.hash(nextProps.coins || []) !== utils.hash(this.props.coins || [])) {
			const query = this.useQuery();
			let coin = find(values(nextProps.coins), ['symbol', query.get("coin") || 'ETH']);
			this.setState({ init: false, coin });
		}
	}

	handleChange = (symbol = 'ETH') => {
		let coin = find(values(this.props.coins), ['symbol', symbol]);

		this.setState({
			coin,
			params: {
				...this.state.params,
				address: "",
				amount: 0,	
			},
		});
		this.props.fetchUserVolume24hAction({ currency: get(coin, 'coin') });
		this.clearErrors();
	}


	async validate() {
		let address = string().required().min(26).label(window.$t('address'));
		if (this.state.coin.type === consts.ETH || this.state.coin.type === consts.ERC_20) {
			address = address.test('isValidAddress', window.$t('validate_invalid_address'),
				(value) => `${get(this.props, `balances.${this.state.coin.symbol}.blockchain_address`, '')}`.toLowerCase() !== `${value}`.toLowerCase())
				.test('isValidEth', window.$t('validate_invalid_address'), (value) => utils.isAddress(value));
		}

		const { coin: coinName } = this.state.coin;
		const balance = get(this.props.balances[coinName], 'available_balance', 0);
		let limits = get(this.props.limits[`${coinName}:${consts.WITH_DRAWAL_LIMITS}`], `minimum_withdrawal`, 0)
		// const pubkey = get(this.props.balances[coinName], 'pubkey', 0);
		const fields = {
			amount: number().required(window.$t("exchange.order_market.amount_field_is_required")).min(utils.formatCurrency(limits)).max(balance, window.$t('Balance insufficient')).label(window.$t('amount')),
		}
		if (this.state.coin.type === consts.CUSTOM_COIN) {
			fields.pubkey = string().required(window.$t('validate_invalid_pubkey')).label("Pubkey");
		} else {
			fields.address = address;
		}

		this.yupValidate = object().shape(fields);

		return super.validate();
	}

	getName = (symbol) => {
		const { coins } = this.props;

		return <div className='d-flex'>
			<div style={{ width: "45px", textAlign: "left" }}>
				<div style={{
					backgroundImage: `url(${coins[symbol]?.icon_image || ''})`, height: '26px',
					width: '26px',
					backgroundSize: 'contain',
					marginRight: "20px",
					display: 'block',
					backgroundRepeat: 'no-repeat',
					fontWeight: 600,
					color: 'black',
				}} alt={symbol} />
			</div>
			<div style={{ width: "50px", textAlign: "left", fontWeight: "bold", lineHeight: '28px' }}>{symbol}</div>
			<div style={{
				width: "150px",
				textAlign: "left",
				fontSize: "12px",
				lineHeight: "28px",
				color: "#76808F",
			}}>{coins[symbol]?.name ?? ''}</div>
		</div>
	}

	getLink = (tx_hash, item) => {
		const { coins } = this.props;
		return (tx_hash && item.is_external ?
			<a className="fz-16" title={`${coins[item.currency]?.transaction_explorer}/tx/${tx_hash}`}
				href={`${coins[item.currency]?.transaction_explorer}/tx/${tx_hash}`} target="_blank">
				<LinkOutlined />
			</a> : ''
		)
	}

	onWithdrawalChange = (amount) => {
		if(new BigNumber(amount).isNaN()){
			this.setState({
				params: { ...this.state.params, amount: 0 }
			});
			return
		}
		this.setState({ params: { ...this.state.params, amount } })
	}

	render() {
		const { params, errors, isLoading } = this.state;
		const { limits, info, balances, currencyMarkets, trans } = this.props;
		const coinSymbol = get(this.state.coin, 'symbol', '');
		const coinType = get(this.state.coin, 'type', '');
		const coin = get(this.state.coin, 'coin', '');
		let fee = get(limits, `${coin}:${info.security_level || 0}.fee`, 0);
		let minimumWithdraw = utils.getPrecision(get(limits, `${coin}:${info.security_level || 0}.minimum_withdrawal`, 0));
		let amountMustPay = params.amount + fee;
		amountMustPay = amountMustPay > fee ? amountMustPay : 0;

		const labelstyle = {
			boxSizing: "border-box",
			minWidth: 0,
			fontSize: '14px',
			color: '#76808f',
			fontWeight: '400',
			textAlign: 'left',
			paddingTop: '4px',
			paddingBottom: '4px',
			backgroundColor: 'inherit',
		};
		return (
			<Translation>
				{(t) => <div className="deposit-wrap user-wallet">
					<div className="left-deposit">
						<div className="text-left">
							{this.state.coin && <Select
								showSearch
								defaultValue={<div>
									<div style={{
										display: 'block',
										backgroundRepeat: 'no-repeat',
										backgroundSize: 'contain',
										height: '24px',
										width: '24px',
										backgroundImage: `url("${get(this.state.coin, 'icon_image', '')}")`,
										float: "left"
									}} className="mr-small mt-ex-small" />
									<div className="ln-normal pr-large">
										{coinSymbol} {get(this.state.coin, 'name', '')}
									</div>
								</div>}
								style={{ color: 'dark', width: '368px' }}
								defaultActiveFirstOption={true}
								showArrow={true}
								filterOption={false}
								onSearch={this.handleSearch}
								onChange={this.handleChange}
								notFoundContent={null}
								size={"large"}
							>
								{chain(this.props.coins).values()
									.filter(({ symbol, name }) => `${symbol}${name}`.toLowerCase().includes(`${this.state.searchText}`.toLowerCase()))
									.map((coin) => {
										return <Option key={coin.symbol}>
											<div style={{
												display: 'block',
												backgroundRepeat: 'no-repeat',
												backgroundSize: 'contain',
												height: '24px',
												width: '24px',
												backgroundImage: `url("${coin?.icon_image || ''}")`,
												float: "left"
											}} className="mr-small mt-ex-small" />
											<div className="ln-normal pr-large">
												{coin.symbol} {coin.name}
											</div>
										</Option>
									}).value()}
							</Select>}
						</div>
					</div>

					<Row className="box-shadow text-left mb-small">
						<Col span={12}>
							<div className="d-flex direct-column">
								<div className="label mr-small">
									{t('user.withdrawal.total_balance')}:
								</div>
								<div className="value fz-32">
									{utils.formatCurrency(get(balances[coin], 'balance', '0.00000000'))} {coinSymbol}
								</div>
							</div>
						</Col>
						<Col span={12}>
							<div className="d-flex direct-column">
								<div className="label mr-small">
									{t('user.withdrawal.available_balance')}:
								</div>
								<div className="value fz-32">
									{utils.formatCurrency(get(balances[coin], 'available_balance', '0.00000000'))} {coinSymbol}
								</div>
							</div>
						</Col>
					</Row>
					<Row className="box-shadow text-left mb-small">
						<Col span={12} className="">
							<div className="text-left p-medium ">
								<div className='mb-medium' >
									<p className='text-normal fontW-700'>{t('user.withdrawal.tips')}</p>
									<div className="op-80 d-flex align-items text-normal mb-small">
										<div className="icon-gridicons_checkmark icon-checkmark" />
										<div>{t('user.withdrawal.coins_confirmations')}</div>
									</div>
									<div className="op-80 d-flex align-items text-normal mb-small">
										<div className="icon-gridicons_checkmark icon-checkmark" />
										<div>{t('user.withdrawal.until_withdrawals')}</div>
									</div>
								</div>
								<div>
									<p className='text-normal fontW-700'>{t('user.deposit.send_only_addr', { coinSymbol })}</p>
									<div className="op-80 d-flex align-items text-normal mb-small">
										<div className="icon-gridicons_checkmark icon-checkmark" />
										<div>{t('user.withdrawal.sending_deposit', { coinSymbol })}</div>
									</div>
								</div>
							</div>
						</Col>
						<Col span={12}>
							<div className="right-deposit address mt-medium">
								{coinType !== consts.CUSTOM_COIN ? <div className="pb-small">
									<FloatLabelInputComponent
										label={t('user.withdrawal.label_receive_address', { coinSymbol })}
										transform="scale(1) translate(0, -50%)"
										className='default-input'
										labelstyle={labelstyle}
										value={params.address}
										overrideFocus={this.clearErrors}
										onChange={({ target }) => this.setState({ params: { ...params, address: target.value.trim() } })} />
									<div className="text-left p-abs no-wrap">
										<Text type='danger'>{utils.upperCaseFirst(errors.address || '')}</Text>
									</div>
								</div> : <div className="pb-small">
									<FloatLabelInputComponent
										label={t('user.withdrawal.label_pubkey')}
										transform="scale(1) translate(0, -50%)"
										className='default-input'
										labelstyle={labelstyle}
										value={params.pubkey}
										overrideFocus={this.clearErrors}
										onChange={({ target }) => this.setState({ params: { ...params, pubkey: target.value.trim() } })} />
									<div className="text-left p-abs no-wrap">
										<Text type='danger'>{utils.upperCaseFirst(errors.pubkey || '')}</Text>
									</div>
								</div>}
								<div className="pt-medium mt-small">
									<FloatLabelNumberComponent
										customPrecision={minimumWithdraw}
										labelstyle={labelstyle}
										className="w-100 default-input"
										transform="scale(1) translate(0, -88%)"
										label={t('user.withdrawal.amount')}
										min={0}
										suffixLength={`${coinSymbol}`.length}
										suffix={<div className="text-black">{coinSymbol}</div>}
										value={params.amount}
										overrideFocus={this.clearErrors}
										onChange={(amount) => this.setState({ params: { ...params, amount: amount || '' } })} />
									<div className="text-left p-abs no-wrap">
										<Text type='danger'>{utils.upperCaseFirst(errors.amount || '')}</Text>
									</div>
								</div>
								{
									coinType === window.c.ERC_20 || window.c.ETH ?
										<div className="pt-medium pb-medium d-flex align-items space-between">
											<div className="  clearfix">
												<div className="fee" >
													{t('user.withdrawal.transaction_fee')}: <span className="bold" style={{ color: "#467CD5" }}>{utils.formatCurrency(fee)}</span> {coinSymbol}
												</div>
												<div className="will-get" >
													{t('user.withdrawal.you_pay')}: <span style={{ color: "#467CD5" }}
														className="bold">{utils.formatCurrency(amountMustPay)}</span> {coinSymbol}
												</div>
											</div>
											<div className="clearfix bold button-1">
												<Radio.Group value={this.state.gasPrice}
													onChange={({ target }) => this.setState({ gasPrice: target.value })}>
													<Radio.Button value="AVERAGE">{t('user.withdrawal.average')}</Radio.Button>
													<Radio.Button value="FAST">{t('user.withdrawal.fast')}</Radio.Button>
													<Radio.Button value="FASTEST">{t('user.withdrawal.fastest')}</Radio.Button>
												</Radio.Group>
											</div>
										</div> : ''
								}
							</div>

							<div className="btn-controls mt-small">
								<Button size={"large"} className="btn-min-width w-100 br-5 text-center"
									style={{ background: "rgba(196, 196, 196, 0.5)", borderRadius: 5 }}
									onClick={this.showModal}
									disabled={isLoading}
									icon={<LoadingSvg name='bars_primary' color={consts.PRIMARY_COLOR}
										hidden={!isLoading} size={25} />}
								>
									<span className="bold px-small">{!isLoading && t('user.withdrawal.submit')}</span>
								</Button>
							</div>
						</Col>
					</Row>

					<div className="deposit-bottom mt-medium">
						<h2 className="text-left">{t('user.withdrawal.recent_history')}</h2>
						<Table columns={this.columns(t)}
							locale={{ emptyText: (<Empty description={<span className="bold">{window.$t('common.empty')}</span>} />) }}
							// className="mw-800"
							dataSource={get(this.props.trans, 'withdrawalHistory', [])}
							pagination={{
								showQuickJumper: true,
								defaultPageSize: 5,
								total: get(trans, 'totalCount', 0),
								onChange: (page, pageSize) => {
									this.fetchWithdrawalHistory((page - 1) * pageSize, pageSize)
								},
								hideOnSinglePage: true,
								responsive: true,
							}}
						/>
					</div>

					<ConfirmModal
						title={t('common.notification')}
						okText={t('common.confirm')}
						okType={'primary'}
						cancelText={t('common.cancel')}
						onConfirm={this.withdrawal}
						onCancel={this.hideModal}
						isVisible={this.state.isVisible}>
						<div>
							{t('user.withdrawal.question')}
						</div>
					</ConfirmModal>
				</div>}
			</Translation>
		);
	}
}

export default WithdrawalComponent;
